"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.arrayOperators = void 0;
exports.arrayOperators = {
    "$any": (data, value, conditionalInstance) => {
        // Ensure data is an array, even if it's empty or a single object
        const dataArray = Array.isArray(data) ? data : [data];
        // Handle empty dataArray by evaluating an empty object
        if (dataArray.length === 0) {
            return conditionalInstance.evaluate({ conditions: value, data: {} });
        }
        const evaluateCondition = (element) => element &&
            typeof element === "object" &&
            conditionalInstance.evaluate({ conditions: value, data: element });
        return dataArray.some(evaluateCondition);
    },
    "$all": (data, value, conditionalInstance) => {
        // Ensure data is an array, even if it's empty or a single object
        const dataArray = Array.isArray(data) ? data : [data];
        // Handle empty dataArray by evaluating an empty object
        if (dataArray.length === 0) {
            return conditionalInstance.evaluate({ conditions: value, data: {} });
        }
        const evaluateCondition = (element) => element &&
            typeof element === "object" &&
            conditionalInstance.evaluate({ conditions: value, data: element });
        return dataArray.every(evaluateCondition);
    },
    "$none": (data, value, conditionalInstance) => {
        // Ensure data is an array, even if it's empty or a single object
        const dataArray = Array.isArray(data) ? data : [data];
        // Handle empty dataArray - if dataArray is empty and operator is $none, return true
        if (dataArray.length === 0) {
            return true;
        }
        const evaluateCondition = (element) => element &&
            typeof element === "object" &&
            conditionalInstance.evaluate({ conditions: value, data: element });
        return dataArray.every((element) => !evaluateCondition(element));
    }
};
//# sourceMappingURL=array.js.map